import { environment } from '../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import type { GetNewsCategoryV2Dto } from '../../../_generated/hka-app-service/model/getNewsCategoryV2Dto';
import { NewsCategoriesV2Service } from '../../../_generated/hka-app-service/api/newsCategoriesV2.service';

@Component({
  selector: 'app-shownewscatecory',
  templateUrl: './shownewscatecory.component.html',
  styleUrls: ['./shownewscatecory.component.scss']
})
export class ShownewscatecoryComponent implements OnInit {
  categories: GetNewsCategoryV2Dto[] = [];
  imageBaseURL: string;
  public loading = false;
  public sortedNewsCategories: GetNewsCategoryV2Dto[];

  constructor(private readonly newsCategoryService: NewsCategoriesV2Service) {}

  ngOnInit() {
    this.getAll();
    this.imageBaseURL = environment.url + '/';
  }

  getAll() {
    this.loading = true;
    this.newsCategoryService.getAllNewsCategories().subscribe((data) => {
      this.categories = data;
      this.loading = false;
      this.sortedNewsCategories = this.categories.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  topFunction() {
    document.body.scrollTop = 0; // for safari
    document.documentElement.scrollTop = 0; // for chrome, firefox, IE, opera
  }
}
